import React, { useEffect, useState } from "react";
import api from "../../services/api";

export default function PresenceBadge({ userId, initialActive }) {
  const [active, setActive] = useState(Boolean(initialActive));

  useEffect(() => {
    if (!userId) return undefined;
    let stop = false;
    const load = async () => {
      try {
        const response = await api.get("/presence", { params: { ids: userId } });
        const row = response.data.data.users?.[userId];
        if (!stop && row) setActive(Boolean(row.active));
      } catch (error) {
        // Keep the last known status.
      }
    };
    load();
    const timer = setInterval(load, 12000);
    return () => {
      stop = true;
      clearInterval(timer);
    };
  }, [userId]);

  return (
    <span className={`inline-flex items-center text-sm font-semibold ${active ? "text-green-600" : "text-gray-500"}`}>
      <span className={`mr-2 h-2.5 w-2.5 rounded-full ${active ? "bg-green-500" : "bg-gray-400"}`} />
      {active ? "Active" : "Inactive"}
    </span>
  );
}
